// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:13:19

export default {
  "id": "noob-shooter-gun-battle-3d",
  "slug": "noob-shooter-gun-battle-3d",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7de4f2b6d2cf4ab587087c8649a1f8bb-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7de4f2b6d2cf4ab587087c8649a1f8bb/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Noob Shooter: Gun Battle 3D",
      "description": "Noob Shooter: Gun Battle 3D is an exciting cooperative shooter created for true fans of action and intense battles. If you like games like CS, Warface and CoD, then this project will definitely not disappoint you. Join your team and engage in battle against opponents, striving for the main goal - to get as many kills as possible. The team that first reaches the required number of frags will be the winner. ",
      "instructions": "The goal of the game \"Noob Shooter: Gun Battle 3D\" is to destroy opponents in a cooperative with a team and be the first to get the required number of kills to win.  Desktop controls: WASD - movement; Mouse - view; Left mouse button - attack; Right mouse button - aim; Space - jump; Shift - run; R - reload; C - crouch; H - grenade; 1,2,3 - weapon selection;  Mobile device controls - touch/swipe.",
      "genres": [
        "Shooter"
      ],
      "tags": [
        "enemies",
        "guns",
        "minecraft",
        "noob"
      ]
    },
    "zh-CN": {
      "title": "新手射手：3D枪战3",
      "description": "《菜鸟射击：枪战3D》是一款专为真正喜爱动作和激烈战斗的玩家打造的激动人心的合作射击游戏。如果你喜欢CS、战Face和CoD等游戏，那么这个项目绝对不会让你失望。加入你的团队，与对手展开战斗，努力实现主要目标——尽可能多地击杀敌人。首先达到所需击杀数的团队将成为赢家。",
      "instructions": "《Noob Shooter: Gun Battle 3D》游戏的目标是与队友合作摧毁对手，并成为第一个达到所需击杀数的人以赢得胜利。桌面操作：WASD - 移动；鼠标 - 视野；左鼠标键 - 攻击；右鼠标键 - 瞄准；空格 - 跳跃；Shift - 快跑；R - 重新装填；C - 蹲下；H - 手榴弹；1,2,3 - 武器选择；移动设备操作 - 触摸/滑动。",
      "genres": [
        "射击游戏"
      ],
      "tags": [
        "敌人",
        "枪械",
        "我的世界",
        "新手"
      ]
    },
    "zh-TW": {
      "title": "新手射手：3D槍戰大亂鬥",
      "description": "Noob Shooter: Gun Battle 3D 是一款令人興奮的合作射擊遊戲，為真正的動作和激烈戰鬥愛好者所創。如果你喜歡 CS、Warface 和 CoD 等遊戲，那麼這個項目絕對不會讓你失望。加入你的隊伍，與對手展開戰鬥，奮鬥於主要目標——盡可能取得最多的殺敵數。首先達到所需分數的隊伍將成為勝者。",
      "instructions": "遊戲《Noob Shooter: Gun Battle 3D》的目標是與隊友合作擊敗對手，並成為第一個達到所需殺敵數量的玩家以獲勝。桌面控制：WASD - 移動；滑鼠 - 觀察視角；左鍵 - 攻擊；右鍵 - 瞄準；空格鍵 - 跳躍；Shift - 跑步；R - 裝彈；C - 蹲下；H - 拳彈；1,2,3 - 武器選擇；移動裝置控制 - 觸控/滑動。",
      "genres": [
        "射手"
      ],
      "tags": [
        "敵人",
        "槍械",
        "Minecraft",
        "新手"
      ]
    },
    "zh-HK": {
      "title": "新手射手：3D槍戰大戰",
      "description": "Noob Shooter: Gun Battle 3D 嚴選合作射擊遊戲，為真摯動作遊戲及激烈戰鬥愛好者打造。如果你喜歡 CS、Warface 及 CoD 等遊戲，這個項目絕對不會讓你失望。加入你的隊伍，與對手進行戰鬥，奮力追求主要目標——取得盡可能多的殺敵數量。首先達到要求殺敵數量的隊伍將獲得勝利。",
      "instructions": "遊戲《Noob Shooter: Gun Battle 3D》的目標是與隊友合作擊敗對手，並率先達到要求的殺敵數量以獲勝。桌面控制：WASD - 移動；滑鼠 - 觀察；左鍵 - 攻擊；右鍵 - 瞄準；空格鍵 - 跳躍；Shift - 跑步；R - 補充彈藥；C - 蹲下；H - 樂器；1,2,3 - 武器選擇；移動裝置控制 - 觸碰/滑動。",
      "genres": [
        "射手"
      ],
      "tags": [
        "敵人",
        "槍械",
        "Minecraft",
        "新手"
      ]
    },
    "ja": {
      "title": "ノーベ・シューター：ガンバトル3D",
      "description": "Noob Shooter: Gun Battle 3Dは、アクションや熾烈な戦闘の真のファンのための魅力的なコラボレーションシューティングゲームです。CS、Warface、CoDのようなゲームが好きであれば、このプロジェクトは絶対にご期待に漏れません。チームに参加して、敵に対抗し、主要な目標を達成しようと殺傷数を競う戦闘に参加してください。最初に要求されるフラッグ数に達したチームが勝者となります。",
      "instructions": "「Noob Shooter: Gun Battle 3D」のゲームの目的は、チームと協力して敵を倒し、必要な殺数を先に達成して勝つことです。デスクトップのコントロール：WASD - 移動；マウス - 表示；左マウスボタン - 攻撃；右マウスボタン - 方向合わせ；スペース - 跳びる；Shift - 走る；R - リロード；C - 坐り込み；H - 手榴弾；1,2,3 - 武器選択；モバイルデバイスのコントロール - タッチ/スワイプ。",
      "genres": [
        "シューティングゲーム"
      ],
      "tags": [
        "敵",
        "銃",
        "マインクラフト",
        "初心者"
      ]
    },
    "ko": {
      "title": "뎁스 샷터: 총격전 3D",
      "description": "노우브 슈터: 간다 3D는 액션과 치열한 전투를 사랑하는 진정한 팬들을 위해 만들어진 흥미로운 협력 슈터입니다. CS, 워페이스, 코드와 같은 게임을 좋아하신다면, 이 프로젝트는 당신을 절대 실망시키지 않을 것입니다. 팀에 가입하여 상대와 전투에 참여하고, 주요 목표를 달성하려고 노력하세요 - 가능한 많은 킬을 따오기. 필요한 프래그 수를 먼저 달성한 팀이 승자가 됩니다.",
      "instructions": "\"노브쏘터:건버틀 3D\" 게임의 목표는 팀과 협력하여 적을 파괴하고, 필요한 킬 수를 최초로 달성하여 승리하는 것입니다. 데스크톱 조작: WASD - 이동; 마우스 - 시야 조절; 왼쪽 마우스 버튼 - 공격; 오른쪽 마우스 버튼 - 정확도 조절; 공간바 - 점프; Shift - 달리기; R - 재충전; C - 앉는 자세; H - 그레나드; 1, 2, 3 - 무기 선택; 모바일 기기 조작 - 터치/스와이프.",
      "genres": [
        "쏘아터기"
      ],
      "tags": [
        "적",
        "총",
        "마인크래프트",
        "초보자"
      ]
    },
    "fr": {
      "title": "Noob Shooter : Bataille d'Armes 3D",
      "description": "Noob Shooter: Gun Battle 3D est un jeu de tir coopératif captivant, créé pour les véritables fans d'action et de batailles intenses. Si vous aimez des jeux comme CS, Warface et CoD, ce projet ne vous décevra certainement pas. Rejoignez votre équipe et engagez-vous dans la bataille contre des adversaires, en visant l'objectif principal : obtenir le plus de frags possible. L'équipe qui atteint d'abord le nombre de frags requis sera la gagnante.",
      "instructions": "L'objectif du jeu \"Noob Shooter: Gun Battle 3D\" est de détruire les adversaires en coopération avec une équipe et d'être le premier à atteindre le nombre de tués requis pour gagner. Commandes du bureau : WASD - déplacement ; Souris - vue ; Bouton gauche de la souris - attaque ; Bouton droit de la souris - viser ; Espace - saut ; Shift - courir ; R - recharger ; C - se prosterner ; H - grenade ; 1, 2, 3 - sélection d'arme ; Commandes sur appareil mobile - toucher / glisser.",
      "genres": [
        "Tirailleur d'élite"
      ],
      "tags": [
        "ennemis",
        "armes",
        "Minecraft",
        "débutant"
      ]
    }
  }
};
